const THEME_YELLOW = ["entrepreneur-yellow-400", "entrepreneur-yellow-300", "entrepreneur-yellow-200"];

const THEME_BLUE = ["accounting-green-200", "accounting-green-100", "accounting-green-50"];

const THEME_GREY = ["prosperity-stone-200", "prosperity-stone-100", "prosperity-stone-50"];

export const getItemBackground = (theme: string, index: number) => {
  switch (theme) {
    case "blue":
      return THEME_BLUE[index];

    case "grey":
      return THEME_GREY[index];

    default:
      return THEME_YELLOW[index];
  }
};
